// eslint-disable-next-line snakecasejs/snakecasejs
export const waitForReady = (...com_props) => new Promise((res) => {
  const poll = setInterval(() => {
    if (com_props.every(prop => prop?.updating !== true)) {
      clearInterval(poll);
      res(com_props);
    }
  }, 125);
});
